export default __webpack_public_path__ + "static/home-owner-hero-1-8c7ded2fda3f69b8c05bebd59dafae80.webp";